module.exports = __webpack_public_path__ + "0aa90375b839cdff247220363e77a216.pdf";